module.exports = __webpack_public_path__ + "img/rule.82843803.png";